import React from 'react'
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import "./Alert.css"
function AlertContainer({msg,severity}) {
  return (
<div className='alert_container mx-3'>
      <Stack sx={{ width: '30%' }} spacing={2}>
                <div className="alert_animate">

      <Alert variant="filled" severity={severity}>
{msg}
      </Alert>
      </div>

    </Stack>
</div>

  )
}

export default AlertContainer